var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-persist/~/lodash/_Symbol.js
 ** module id = 117
 ** module chunks = 0
 **/